import { Button } from "~/react/ui/button"
import { Icon } from "~/react/ui/icon"
import { Tooltip, TooltipContent, TooltipTrigger } from "~/react/ui/tooltip"
import { useCampaignContent } from "../campaign_content_context"
import { CampaignStepCard } from "./campaign_step_card"
import { t } from "../i18n"

export function CampaignContentSidebar() {
  const {
    followUps,
    selectedStep,
    setSelectedStep,
    editable,
    canAddFollowUp,
    maxFollowUps,
    addFollowUp,
    isSaving,
  } = useCampaignContent()

  const isMaxFollowUpsReached = followUps.length >= maxFollowUps

  return (
    <aside className="campaign-content-sidebar">
      <ul className="campaign-content-sidebar__steps">
        {followUps.map((followUp, index) => (
          <li key={followUp.id} className="campaign-content-sidebar__step-item">
            <CampaignStepCard
              followUp={followUp}
              isSelected={followUp.step === selectedStep}
              onSelect={() => setSelectedStep(followUp.step)}
              abTestEnabled={followUp.ab_testing_enabled}
            />

            {index < followUps.length - 1 && (
              <div className="campaign-step-connector" aria-hidden="true" />
            )}
          </li>
        ))}
      </ul>

      {editable && (
        <>
          {/* TODO(dev, CAMPAIGNS_AB_TESTING): Improve tooltip behavior when max follow-ups reached:
              - Show tooltip on hover (not always open)
              - Tweak button visual state to indicate disabled reason
              - Consider using aria-describedby for better accessibility */}
          <Tooltip
            open={isMaxFollowUpsReached ? undefined : false}
            delayDuration={0}
          >
            <TooltipTrigger asChild>
              <Button
                variant="default"
                size="sm"
                fullWidth
                onClick={addFollowUp}
                disabled={!canAddFollowUp || isSaving}
              >
                <Icon icon="plus" />
                {t("js.campaigns.content.add_step")}
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              {t("js.campaigns.content.max_follow_ups_reached", {
                count: maxFollowUps - 1,
              })}
            </TooltipContent>
          </Tooltip>
        </>
      )}

      {editable && (
        <Button
          variant="ai"
          fullWidth
          className="campaign-content-sidebar__generate-button"
        >
          <Icon icon="sparkle" />
          {t("js.campaigns.content.generate_sequence")}
        </Button>
      )}
    </aside>
  )
}
